"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xmlDeserializationConfig = exports.xmlSerializationConfig = exports.html5DeserializationConfig = exports.html5SerializationConfig = void 0;
var util_1 = require("./util");
var properties_1 = require("./properties");
var html5VoidTags = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
};
exports.html5SerializationConfig = function () { return ({
    isFragment: function (node) { return util_1.isElement(node) && node.tagName === 'fragment'; },
    serializeTagName: function (name) { return name; },
    serializeAttribute: function (tagName, name, value) { return properties_1.hastPropertyToMarkup(properties_1.htmlSpace, name, value); },
    serializeAsSelfClosing: function (node) { return html5VoidTags[node.tagName]; },
}); };
exports.html5DeserializationConfig = function () { return ({
    deserializeTagName: function (name) { return name.toLowerCase(); },
    deserializeAttribute: function (tagName, name, value) {
        return properties_1.markupAttributeToHastProperty(properties_1.htmlSpace, name, value);
    },
}); };
exports.xmlSerializationConfig = function () { return ({
    isFragment: function (node) { return false; },
    serializeTagName: function (name) { return name; },
    serializeAttribute: function (tagName, name, value) { return properties_1.hastPropertyToMarkup(properties_1.xmlSpace, name, value); },
    serializeAsSelfClosing: function (node) { return !node.children || node.children.length === 0; },
}); };
exports.xmlDeserializationConfig = function () { return ({
    deserializeTagName: function (name) { return name; },
    deserializeAttribute: function (tagName, name, value) {
        return properties_1.markupAttributeToHastProperty(properties_1.xmlSpace, name, value);
    },
}); };
